// noinspection NpmUsedModulesInstalled,DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { saveAs } from 'file-saver';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@/modules/common/components/Button';
import ButtonGroup from '@/modules/common/components/ButtonGroup';
import DownloadMenu from '@/modules/common/components/DownloadMenu';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import DateRangeField from '@/modules/common/components/DateRangeField';
import SelectStatusInternal from '@/modules/common/components/SelectStatusInternal';
import AutocompleteTypeNameField from '@/modules/common/components/AutocompleteTypeNameField';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { isEmptyObject, base64toBlob } from '~/common';
import { actionSetDownloadingReportSummary } from '@/modules/application/actions/downloading';
import { getTypes } from '../../common';

const Top = (props) => {
    const [_types, setTypes] = useState([]);
    const { offerName, } = useParams();

    const fetch = (format) => {
        const url = `/api${props.location.pathname}download/${format}/?${props.router.urlSearchParams.toString()}`;
        props.setFetching(true);
        props.fetch.get(url)
            .then(({ok, data}) => {
                if (ok) {
                    const blob = base64toBlob(data.blob);
                    saveAs(blob, `report_summary.${format}`);
                }
            })
            .finally(() => {
                props.setFetching(false);
            });
    };

    useEffect(() => {
        if (props.types.length > 0 && props.report) {
            const types = getTypes(props.types, props.report, offerName);
            setTypes(types);
        }
    }, [props.types, props.report]);

    const handleClickDownload = (popupState, format) => () => {
        popupState.close();
        fetch(format);
    };

    return (
        <ContentBodyTop
            left={
                (!isEmptyObject(props.report))
                    ? <DownloadMenu fetching={props.fetching} onClickDownload={handleClickDownload}/>
                    : null
            }
            right={
                <form id="form-filter" onSubmit={props.onSubmitFilter}>
                    <AutocompleteTypeNameField types={_types} value={props.valuesFilter.typeName}
                                               setValue={(value) => props.setValuesFilter({
                                                   ...props.valuesFilter,
                                                   typeName: value
                                               })}
                    />
                    <SelectStatusInternal fullWidth={false}
                                          value={props.valuesFilter.statusInternal}
                                          onChange={(event) => props.setValuesFilter({
                                              ...props.valuesFilter,
                                              statusInternal: event.target.value,
                                          })}
                    />
                    <DateRangeField value={props.valuesFilter.date}
                               setValue={(value) => props.setValuesFilter({
                                   ...props.valuesFilter,
                                   date: value,
                               })}
                    />
                    <ButtonGroup>
                        {(props.isFiltered)
                            ? <Button onClick={props.onClickResetFilter}>Сбросить</Button>
                            : null
                        }
                        <Button type="submit">Применить</Button>
                    </ButtonGroup>
                </form>
            }/>
    );
};

Top.propTypes = {
    report: PropTypes.object.isRequired,
    valuesFilter: PropTypes.object.isRequired,
    setValuesFilter: PropTypes.func.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    onSubmitFilter: PropTypes.func.isRequired,
    onClickResetFilter: PropTypes.func.isRequired,
};

let Component = Top;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        types: state.types,
        fetching: state.downloading.reportSummary,
    }),
    (dispatch) => ({
        setFetching: bindActionCreators(actionSetDownloadingReportSummary, dispatch),
    })
)(Component);
